import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Box, Typography, TextField, Button, Grid, Card, CardMedia, IconButton, Paper, Alert, Avatar } from "@mui/material";
import {  AddAPhoto } from "@mui/icons-material";
import { goodsAPI, imgAPI, partnersAPI } from '../../Api';

const AddGoods = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    code: "",
    sku: "",
    name: "",
    category: "70167260",
    photos: "",
    description: "",
    width: "1",
    height: "1",
    length: "1",
    weight: "1",
    stock: "999999",
    mainPhoto: "",
    yandex_price: "",
    partner_id: "",
    errors: [],
    funpay: [
      { name: '', link: '', active: true }
    ]
  });
  const [partners, setPartners] = useState([]);
  const [editorContent, setEditorContent] = useState('');
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState(null);
  const [photoPreviews, setPhotoPreviews] = useState([]);

  const fieldsList = [
    { key: "name", label: "Название", disabled: false },
    { key: "code", label: "Код товара", disabled: false },
    { key: "sku", label: "Артикул Маркета (Ссылка на фанпей)", disabled: false },
    { key: "category", label: "Категория", disabled: true },
    { key: "description", label: "Описание", disabled: false },
    { key: "width", label: "Ширина", disabled: true },
    { key: "height", label: "Высота", disabled: true },
    { key: "length", label: "Длина", disabled: true },
    { key: "weight", label: "Вес", disabled: true },
    { key: "stock", label: "Остатки", disabled: true },
    { key: "yandex_price", label: "Цена в Яндекс.Маркет / ФанПей", disabled: false },
  ];

  useEffect(() => {
    // Получаем список партнеров
    const fetchPartners = async () => {
      try {
        const { data } = await partnersAPI.getPartners();
        setPartners(data.data || []);
      } catch (error) {
        setPartners([]);
      }
    };
    fetchPartners();
    if (id) {
      const fetchGoods = async () => {
        try {
          const { data } = await goodsAPI.getGoodsById(id);
          console.log(data.data);
          setFormData({ ...data.data, funpay: data.data.funpay && data.data.funpay.length > 0 ? data.data.funpay : [{ name: '', link: '', active: true }] });
          setEditorContent(data.description);
          
          if(data.data.photos) {
            let photo = await imgAPI.getImg(data.data.photos)
      
            setPhotoPreviews([photo]);
          }
        } catch (error) {
          console.log(error);
        }
      };
      fetchGoods();
    }
  }, [id]);
  
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Функции для работы с funpay ссылками
  const handleFunpayChange = (idx, field, value) => {
    const newFunpay = [...formData.funpay];
    newFunpay[idx][field] = value;
    setFormData({ ...formData, funpay: newFunpay });
  };

  const handleAddFunpay = () => {
    setFormData({ ...formData, funpay: [...formData.funpay, { name: '', link: '', active: true }] });
  };

  const handleRemoveFunpay = (idx) => {
    const newFunpay = formData.funpay.filter((_, i) => i !== idx);
    setFormData({ ...formData, funpay: newFunpay.length > 0 ? newFunpay : [{ name: '', link: '', active: true }] });
  };

  const handlePartnerChange = (e) => {
    setFormData({ ...formData, partner_id: e.target.value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    setFormData({ 
      ...formData, 
      photos: file  // Сохраняем именно файл, а не FormData
    }); 
    
    setPhotoPreviews([URL.createObjectURL(file)]); 
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  
  const data = new FormData();
  
  // Добавляем все текстовые поля
  for(let k in formData) {
    if (k !== 'photos' && k !== 'funpay') {
      data.append(k, formData[k]);
    }
  }
  // funpay сериализуем в JSON
  if (formData.funpay && Array.isArray(formData.funpay)) {
    data.append('funpay', JSON.stringify(formData.funpay));
  }
  // Добавляем выбранного партнера
  // if (formData.partner_id) {
  //   data.append('partner_id', formData.partner_id);
  // }
  
  // Добавляем файл, если он есть
  if (formData.photos) {
    data.append('photos', formData.photos);
  }

  if(validateForm()){
    let text = ''
    let response = null;
    if(id) {
      response = await goodsAPI.updateGoods(id, data)
      text = 'Товар успешно обновлен!'
    } else {
      response = await goodsAPI.createGoods(data)
      text = 'Товар успешно добавлен!'
    }
    // Остальной код без изменений...
    if (response.data?.success) {
      setAlert(<Alert severity="success">{text}</Alert>);
 
      setTimeout(() => {
        navigate('/goods/list')     
      }, 1000);
   
    } else {
      setAlert(<Alert severity="error">Ошибка!</Alert>);
    }
  } else {
    setAlert(<Alert severity="error">Поля Код товара, Название товара обязательны к заполнению</Alert>);
  }
};
  const validateForm = () => {
    let newErrors = {};
    ["code", "name"].forEach(field => {
      if (!formData[field]) newErrors[field] = "";
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, p: 3, boxShadow: 3, borderRadius: 2, bgcolor: "#fff" }}>
        {formData.errors.length > 0 && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="h5" align="center" gutterBottom>Ошибкаи про импорте</Typography>
          {formData.errors.map(error => (
            <Alert severity="error">{error.message}</Alert>
          ))}
          </Box>
    
        )}
        <Typography variant="h5" align="center" gutterBottom>
          {id ? 'Редактирование товара' : 'Добавление товара'}
        </Typography>
        {alert && <Box sx={{ mb: 2 }}>{alert}</Box>}
        <form onSubmit={handleSubmit}>
          {/* Выбор магазина */}
          <Grid item xs={12} md={6}>
            <TextField
              select
              label="Магазин"
              name="partner_id"
              value={formData.partner_id}
              onChange={handlePartnerChange}
              fullWidth
              SelectProps={{ native: true }}
              required
              sx={{ mb: 2 }}
            >
              <option value="">Выберите магазин</option>
              {partners.map((partner) => (
                <option key={partner._id} value={partner._id}>{partner.name}</option>
              ))}
            </TextField>
          </Grid>
          {/* Карточка с фотографией товара */}
          <Grid container spacing={3} sx={{ mb: 3 }} alignItems="center">
            <Grid item xs={12} md={4}>
            <Card sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200, borderRadius: 2, bgcolor: "#f0f0f0" }}>
  {photoPreviews.length > 0 ? (
    <Card sx={{ position: "relative" }}>
      <CardMedia
        component="img"
        src={photoPreviews[0]}
        alt="preview"
        sx={{ objectFit: "cover", height: "100%", width: "100%", borderRadius: 2 }}
      />
      <IconButton
        onClick={() => document.getElementById("file-input").click()} // При клике на иконку запускаем загрузку файла
        sx={{ 
          position: "absolute", 
          top: 10, 
          right: 10, 
          backgroundColor: "rgba(255, 255, 255, 0.7)", 
          borderRadius: "50%" 
        }}
      >
        <AddAPhoto sx={{ color: "#777" }} />
      </IconButton>
      <input
        id="file-input"
        type="file"
        hidden
        onChange={handleFileChange}
      />
    </Card>
  ) : (
    <IconButton component="label">
      <Avatar sx={{ bgcolor: "#ddd", width: 100, height: 100 }}>
        <AddAPhoto sx={{ color: "#777" }} />
      </Avatar>
      <input
        id="file-input"
        type="file"
        hidden
        onChange={handleFileChange}
      />
    </IconButton>
  )}
</Card>

            </Grid>

            {/* Инпуты товара */}
            <Grid item xs={12} md={8}>
              <Grid container spacing={2}>
                {fieldsList.slice(0, 4).map(({ key, label, disabled }) => (
                  <Grid item xs={12} sm={6} key={key}>
                    <TextField
                      disabled={disabled}
                      label={label}
                      variant="outlined"
                      size="small"
                      fullWidth
                      name={key}
                      value={formData[key]}
                      onChange={handleChange}
                      error={Boolean(errors[key])}
                      helperText={errors[key] || ""}
                      sx={{
                        height: 40,
                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6a1b9a", // Цвет обводки при фокусе
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                          color: "#6a1b9a", // Цвет метки при фокусе
                        },
                      }}
                
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>

          {/* Описание товара и дополнительные параметры */}
          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12}>
              <TextField
                label="Описание"
                variant="outlined"
                size="small"
                fullWidth
                multiline
                rows={4}
                name="description"
                value={formData.description}
                onChange={handleChange}
                sx={{
                  height: 100,
                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#6a1b9a", // Цвет обводки при фокусе
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#6a1b9a", // Цвет метки при фокусе
                  },
                }}
              />
            </Grid>
            {fieldsList.slice(7).map(({ key, label, disabled }) => (
              <Grid item xs={12} sm={6} key={key}>
<TextField
  disabled={disabled}
  label={label}
  variant="outlined"
  size="small"
  fullWidth
  name={key}
  value={formData[key]}
  onChange={handleChange}
  error={Boolean(errors[key])}
  helperText={errors[key] || ""}
  sx={{
    height: 40,
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#6a1b9a", // Цвет обводки при фокусе
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#6a1b9a", // Цвет метки при фокусе
    },
  }}
/>
              </Grid>
            ))}
          </Grid>

          {/* --- FUNPAY LINKS --- */}
          <Box sx={{ mt: 4, mb: 2 }}>
            <Typography variant="h6" gutterBottom>FunPay ссылки</Typography>
            {formData.funpay && formData.funpay.map((item, idx) => (
              <Grid container spacing={2} alignItems="center" key={idx} sx={{ mb: 1 }}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Имя"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={item.name}
                    onChange={e => handleFunpayChange(idx, 'name', e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Ссылка"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={item.link}
                    onChange={e => handleFunpayChange(idx, 'link', e.target.value)}
                  />
                </Grid>
                <Grid item xs={6} sm={1}>
                  <Button
                    variant={item.active ? "contained" : "outlined"}
                    color={item.active ? "success" : "secondary"}
                    size="small"
                    onClick={() => handleFunpayChange(idx, 'active', !item.active)}
                  >
                    {item.active ? 'Активна' : 'Неактивна'}
                  </Button>
                </Grid>
                <Grid item xs={6} sm={1}>
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    onClick={() => handleRemoveFunpay(idx)}
                    disabled={formData.funpay.length === 1}
                  >
                    Удалить
                  </Button>
                </Grid>
              </Grid>
            ))}
            <Button variant="outlined" onClick={handleAddFunpay} sx={{ mt: 1 }}>+ Добавить ссылку</Button>
          </Box>

          {/* Кнопка для добавления товара */}
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              sx={{ width: "200px", backgroundColor: "#6a1b9a", }}
            >
              {id ? "Сохранить" : "Добавить товар"}
            </Button>
          </Box>
        </form>
      </Box>
    </Container>
  );
};

export default AddGoods;
